import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class SettingsBillingPlansRoute extends Route {
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('billing') declare billingService: Service.Billing;

	override queryParams = {
		action: {
			refreshModel: true,
		},
	};

	override beforeModel() {
		document.body.id = 'page-account-billing';

		if (this.accountService.isClient) {
			this.navigationService.replaceRoute('settings.billing.index');
		}
	}

	override model(params: { action?: string }) {
		if (params.action === 'open-subscription-popup') {
			this.billingService.switchToExpiredPromotionPlan('paid_trial_email');
		}
	}
}
